export type Defined = {
  PUBLIC_FLEEK_REST_API_HOST?: string;
  PUBLIC_DASHBOARD_APP_URL?: string;
  PUBLIC_BEEHIIV_PROXY_SERVER_URL?: string;
  PUBLIC_AUTOFUN_CALLBACK_URL?: string;
  PUBLIC_GRAPHQL_API_URL?: string;
  PUBLIC_DYNAMIC_ENVIRONMENT_ID?: string;
  PUBLIC_AGENTS_BASE_PATH?: string;
  PUBLIC_REDIRECT_URL_UNAUTHENTICATED?: string;
  PUBLIC_PERSONA_GENERATOR_API_URL?: string;
};

export const defined: Defined = {
  PUBLIC_FLEEK_REST_API_HOST: process.env.PUBLIC_FLEEK_REST_API_HOST,
  PUBLIC_DASHBOARD_APP_URL: process.env.PUBLIC_DASHBOARD_APP_URL,
  PUBLIC_BEEHIIV_PROXY_SERVER_URL: process.env.PUBLIC_BEEHIIV_PROXY_SERVER_URL,
  PUBLIC_AUTOFUN_CALLBACK_URL: process.env.PUBLIC_AUTOFUN_CALLBACK_URL,
  PUBLIC_GRAPHQL_API_URL: process.env.PUBLIC_GRAPHQL_API_URL,
  PUBLIC_DYNAMIC_ENVIRONMENT_ID: process.env.PUBLIC_DYNAMIC_ENVIRONMENT_ID,
  PUBLIC_AGENTS_BASE_PATH: process.env.PUBLIC_AGENTS_BASE_PATH,
  PUBLIC_REDIRECT_URL_UNAUTHENTICATED:
    process.env.PUBLIC_REDIRECT_URL_UNAUTHENTICATED,
  PUBLIC_PERSONA_GENERATOR_API_URL:
    process.env.PUBLIC_PERSONA_GENERATOR_API_URL,
};

export const getDefined = (key: keyof typeof defined): string => {
  const value = defined[key];

  if (value === undefined || value === null) {
    throw new Error(
      `Expected key "${key}" to be defined but got ${typeof value}`,
    );
  }

  if (typeof value !== 'string') {
    throw new Error(
      `Expected key "${key}" to be string but got ${typeof value}`,
    );
  }

  return value;
};

// Use to override `defined`
export const setDefined = (settings: Partial<Defined>) => {
  const override = { ...defined, ...settings };
  Object.assign(defined, override);
};

export const DEFINED_OVERRIDES_FILENAME = 'defined_overrides.json';
